module.exports = ":host {\n    overflow:auto;\n}\n\n\ninput {\n    width: calc(100% - 20px);\n    margin-left: 10px;\n    margin-right: 10px;\n    height: 30px;\n}\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/explorer/explorer.css
 ** module id = 801
 ** module chunks = 0
 **/